import Clazz from './Clazz';

/**
 * 单例类的基类
 */
export default class Singleton extends Clazz {
    /**
     * 构造函数
     * @return {undefined}
     */
    constructor(options) {
        super(options);
    }

    /**
     * 销毁单例实例对象
     * @return {undefined}
     */
    destroy() {
        this.constructor.instance = null;
    }

    /**
     * 单例实例
     */
    static instance;

    /**
     * 获取单例对象的实例
     * @param  {...all} rest 参数
     * @return {object}  单例对象的实例
     */
    static getInstance(...rest) {
        if (!this.instance) {
            this.instance = new this(...rest);
        }

        return this.instance;
    }
}
